import { render, staticRenderFns } from "./Retours.vue?vue&type=template&id=d450a6e4&scoped=true&lang=true&"
import script from "./Retours.vue?vue&type=script&lang=js&"
export * from "./Retours.vue?vue&type=script&lang=js&"
import style0 from "./Retours.vue?vue&type=style&index=0&id=d450a6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d450a6e4",
  null
  
)

export default component.exports